import { Injectable, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageResizeService {
  private windowSize = new BehaviorSubject<{ width: number; height: number }>({
    width: 0,
    height: 0,
  });
  windowSize$ = this.windowSize.asObservable();

  constructor(
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.updateWindowSize(); // Initialize with current size
      window.addEventListener('resize', this.onResize.bind(this));
    }
  }

  private onResize(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.run(() => {
        this.updateWindowSize();
      });
    }
  }

  private updateWindowSize(): void {
    const width = window.innerWidth;
    const height = window.innerHeight;
    this.windowSize.next({ width, height });
  }
}